'use client';

import DatePicker from '@/ui/DatePicker';
import Select, { SelectOption } from '@/ui/Select';
import { FC } from 'react';

type ReportModalSidebarProps = {
    companyName: string;
    periodFrom: string;
    periodTo: string;
    setPeriodFrom: (value: string) => void;
    setPeriodTo: (value: string) => void;
    platformOptions: SelectOption[];
    selectedPlatformValues: string[];
    setSelectedPlatformValues: (values: string[]) => void;
    productGroupOptions: SelectOption[];
    selectedProductGroupValues: string[];
    setSelectedProductGroupValues: (values: string[]) => void;
    brandGroupOptions: SelectOption[];
    selectedBrandGroupValues: string[];
    setSelectedBrandGroupValues: (values: string[]) => void;
    canApplyMaxPeriod: boolean;
    applyMaxPeriod: () => void;
};

const ReportModalSidebar: FC<ReportModalSidebarProps> = ({
    companyName,
    periodFrom,
    periodTo,
    setPeriodFrom,
    setPeriodTo,
    platformOptions,
    selectedPlatformValues,
    setSelectedPlatformValues,
    productGroupOptions,
    selectedProductGroupValues,
    setSelectedProductGroupValues,
    brandGroupOptions,
    selectedBrandGroupValues,
    setSelectedBrandGroupValues,
    canApplyMaxPeriod,
    applyMaxPeriod,
}) => {
    return (
        <div className="space-y-4 xl:col-span-4">
            <div className="rounded-lg border border-slate-200 bg-white p-4">
                <div className="space-y-3">
                    <div className="space-y-2 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm">
                        <div className="flex items-start gap-3">
                            <span className="shrink-0 text-slate-600">Компания</span>
                            <span className="max-w-[70%] truncate text-left font-semibold text-slate-900">
                                {companyName || '—'}
                            </span>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="shrink-0 text-slate-600">Период</span>
                            <div className="flex min-w-0 flex-wrap items-center gap-2">
                                <div className="flex shrink-0 items-center gap-1">
                                    <span className="text-xs text-slate-500">с</span>
                                    <DatePicker
                                        className="w-[110px]"
                                        selectedDate={periodFrom}
                                        setSelectedDate={setPeriodFrom}
                                        uiSize="compact"
                                        placeholder=""
                                    />
                                </div>
                                <div className="flex shrink-0 items-center gap-1">
                                    <span className="text-xs text-slate-500">по</span>
                                    <DatePicker
                                        className="w-[110px]"
                                        selectedDate={periodTo}
                                        setSelectedDate={setPeriodTo}
                                        uiSize="compact"
                                        placeholder=""
                                    />
                                </div>
                                <button
                                    type="button"
                                    onClick={applyMaxPeriod}
                                    disabled={!canApplyMaxPeriod}
                                    className="inline-flex h-7 items-center rounded-md border border-slate-300 px-2 text-xs font-semibold text-slate-700 transition hover:border-slate-400 hover:bg-slate-100 disabled:cursor-not-allowed disabled:border-slate-200 disabled:text-slate-400"
                                >
                                    Макс
                                </button>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="shrink-0 pt-1 text-slate-600">Платформы</span>
                            <Select
                                id="aiback-report-filter-platforms"
                                ariaLabel="Фильтр платформ отчета AIBACK"
                                options={platformOptions}
                                values={selectedPlatformValues}
                                onValuesChange={setSelectedPlatformValues}
                                multiple
                                uiSize="compact"
                                className="min-w-0 flex-1"
                            />
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="shrink-0 pt-1 text-slate-600">Товары</span>
                            <Select
                                id="aiback-report-filter-product-groups"
                                ariaLabel="Фильтр групп товаров отчета AIBACK"
                                options={productGroupOptions}
                                values={selectedProductGroupValues}
                                onValuesChange={setSelectedProductGroupValues}
                                multiple
                                uiSize="compact"
                                className="min-w-0 flex-1"
                            />
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="shrink-0 pt-1 text-slate-600">Бренды</span>
                            <Select
                                id="aiback-report-filter-brand-groups"
                                ariaLabel="Фильтр групп брендов отчета AIBACK"
                                options={brandGroupOptions}
                                values={selectedBrandGroupValues}
                                onValuesChange={setSelectedBrandGroupValues}
                                multiple
                                uiSize="compact"
                                className="min-w-0 flex-1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportModalSidebar;
